import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { PreloaderComponent } from './modules/common/preloader/preloader.component';
import { NavBarComponent } from './modules/common/nav-bar/nav-bar.component';
import { FooterComponent } from './modules/common/footer/footer.component';
import { AuthService } from './service/auth.service';
import { UserService } from './service/user.service';
import { HttpsService } from './service/https.service';
import { HttpService } from './service/http.service';
import { HttpClientModule } from '@angular/common/http';
import { HeaderComponent } from './external/header/header.component';


@NgModule({
    declarations: [
        AppComponent,
        NavBarComponent,
        FooterComponent,
        PreloaderComponent,
        HeaderComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        AppRoutingModule
    ],
    providers: [HttpService,HttpsService,AuthService,UserService,],
    bootstrap: [AppComponent]
})
export class AppModule { }
